import React from 'react';
import {ServiceBase} from '../ServiceBase';
import {
    IFloatingBubbleContent,
    IFloatingBubbleHandler,
    IFloatingBubblesService
} from './floating-bubbles.service.interface';
import { action, observable, runInAction, makeObservable } from 'mobx';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {Check} from '@sparkware/app-utils';

export class FloatingBubblesService extends ServiceBase implements IFloatingBubblesService {
    @observable.ref
    bubbles: IFloatingBubbleContent[] = [];

    constructor(services: IServiceFactoryExtended) {
        super(services);

        makeObservable(this);
    }

    @action.bound
    addBubble(content: IFloatingBubbleContent): IFloatingBubbleHandler {
        content = new BubbleContentDecorator(content, this.services);
        this.bubbles = [...this.bubbles, content];
        return {
            remove: ()  => {
                const bubbleToRemoveIndex = this.bubbles.findIndex(b => b.id === content.id);
                if(bubbleToRemoveIndex >= 0) {
                    runInAction(() => {
                        this.bubbles.splice(bubbleToRemoveIndex, 1);
                        this.bubbles = [...this.bubbles];
                    });
                }
            }

        };
    }
}


class BubbleContentDecorator implements IFloatingBubbleContent {
    constructor(private readonly _originalBubble: IFloatingBubbleContent, private readonly _services: IServiceFactoryExtended) {
        this._id = this._services.tools.getGuid();
    }


    private readonly _id: string;

    get id(): string {
        return this._originalBubble.id || this._id;
    }

    get isVisible(): boolean {
        if(Check.isNullOrUndefined(this._originalBubble.isVisible)) {
            return true;
        }
        return this._originalBubble.isVisible;
    }

    render(): React.ReactNode {
        return this._originalBubble.render();
    }

}